import { IgButton, IgTooltip } from "@intelligems/ig-theme";

export interface TemplateRuleActionsProps {
  /** The button's label — "Create rule" before the rule exists, else "Save". */
  saveLabel: string;
  isSaveDisabled: boolean;
  /** Hover copy explaining a disabled state that is not self-evident. */
  disabledActionHint?: string;
  /**
   * The buffer matches what is persisted, so the button steps back to neutral.
   * It stays ENABLED — re-saving is idempotent and is the way out of a failed
   * publish — but a permanently blue primary is the page's loudest control
   * claiming there is work outstanding when there is none. The code rule's
   * split button carries the same state; see `WorkspaceActions`.
   */
  isSettled?: boolean;
  onSave: () => void;
}

/**
 * The template rule's one write action. There is no second "publish" verb
 * because saving is what deploys — the configuration a save writes is the
 * configuration that serves. Behavior is verified through the cart preview UI,
 * not from here.
 */
export const TemplateRuleActions = ({
  saveLabel,
  isSaveDisabled,
  disabledActionHint,
  isSettled = false,
  onSave,
}: TemplateRuleActionsProps) => (
  <IgTooltip title={disabledActionHint ?? ""}>
    {/* span keeps the tooltip reachable while the button is disabled */}
    <span>
      <IgButton
        color={isSettled ? "secondary" : "primary"}
        disabled={isSaveDisabled}
        onClick={onSave}
        sx={{ height: 40, minWidth: 100, px: 4 }}
      >
        {saveLabel}
      </IgButton>
    </span>
  </IgTooltip>
);
